import * as React from "react";
import { forwardRef } from "react";
const SvgSortIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 12, viewBox: "0 0 17 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.33325 1H8.83325M1.33325 6H7.16659M1.33325 11H7.16659M10.4999 8.5L12.9999 11M12.9999 11L15.4999 8.5M12.9999 11V1", stroke: "#111111", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSortIcon);
export default ForwardRef;
